import { createApi } from '@reduxjs/toolkit/query/react';
import { deviceType, osName } from 'react-device-detect';

import { getDeviceFingerprint } from '@admin-panel/utils';

import { baseQueryWithZodValidation } from '../lib/utils/baseQueryWithZodValidation';
import { overrideFetchBaseQuery } from '../lib/utils/overrideFetchBaseQuery';

import type { PushEventRequestPayload } from './types';

type StoredUser = {
  id?: number | string;
};

const readStoredUser = (): StoredUser | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const rawUser = localStorage.getItem('user');
  if (!rawUser) {
    return null;
  }

  try {
    return JSON.parse(rawUser) as StoredUser;
  } catch {
    return null;
  }
};

export const eventsApi = createApi({
  reducerPath: 'eventsApi',
  baseQuery: baseQueryWithZodValidation(
    overrideFetchBaseQuery({
      urlSuffix: 'events',
      includePlatform: false,
    }),
    {
      passThroughChecks: true,
    },
  ),
  endpoints: builder => ({
    pushEvent: builder.mutation<
      {
        status: string;
      },
      PushEventRequestPayload
    >({
      query: body => {
        const enrichedPayload = structuredClone(body);
        const currentUser = readStoredUser();

        enrichedPayload.device_id = getDeviceFingerprint();

        if (currentUser?.id != null) {
          enrichedPayload.customer_id = String(currentUser.id);
        }

        enrichedPayload.event_params.device_type = deviceType;
        enrichedPayload.event_params.device_os = osName;

        return {
          url: 'push',
          method: 'POST',
          body: enrichedPayload,
        };
      },
    }),
  }),
});

export const { usePushEventMutation } = eventsApi;
